import { clsx } from "keycloakify/tools/clsx";
import type { PageProps } from "keycloakify/login/pages/PageProps";
import { useGetClassName } from "keycloakify/login/lib/useGetClassName";
import type { KcContext } from "../kcContext";
import type { I18n } from "../i18n";
import {Button, Form} from "react-bootstrap";

export default function LoginResetPassword(props: PageProps<Extract<KcContext, { pageId: "login-reset-password.ftl" }>, I18n>) {
    const { kcContext, i18n, doUseDefaultCss, Template, classes } = props;

    const { getClassName } = useGetClassName({
        doUseDefaultCss,
        classes
    });

    const { url, realm, auth } = kcContext;

    const { msg, msgStr } = i18n;

    return (
        <Template
            {...{ kcContext, i18n, doUseDefaultCss, classes }}
            displayMessage={false}
            headerNode={msg("emailForgotTitle")}
            infoNode={msg("emailInstruction")}
        >
            <Form id="kc-reset-password-form" action={url.loginAction} method="post">
                <Form.Group>
                    <Form.Label htmlFor="username">
                        {!realm.loginWithEmailAllowed
                            ? msg("username")
                            : !realm.registrationEmailAsUsername
                                ? msg("usernameOrEmail")
                                : msg("email")}
                    </Form.Label>
                    <Form.Control
                        type="text"
                        className={"bg-white"}
                        id="username"
                        name="username"
                        autoFocus
                        defaultValue={auth !== undefined && auth.showUsername ? auth.attemptedUsername : undefined}
                    />
                </Form.Group>
                <Form.Group>
                    <div className={"py-3"}>
                        <a href={url.loginUrl}>{msg("backToLogin")}</a>
                    </div>
                    <Button
                        variant="outline-primary"
                        type="submit"
                    >
                        {msgStr("doSubmit")}
                    </Button>
                </Form.Group>
            </Form>
        </Template>
    );
}
